import type { MPRAppMode } from 'MPREmbedded';

import type { MPRInputMode, MPRTool } from '@/features/MPR';

export type MPR2Tool = Exclude<MPRTool, 'rotateMode'>;

export type MPR2Mode = Exclude<MPRInputMode, 'rotateMode'>;

export const MPR2_TOOLS: MPR2Tool[] = [
  'mainMode',
  'contrastBrightnessMode',
  'panMode',
  'zoomMode',
  'scrollThroughVolumeMode',
  'reset',
];

export const MPR2_EMBEDDED_MODE_BY_TOOL: Record<MPR2Mode, MPRAppMode> = {
  mainMode: 'mainMode',
  contrastBrightnessMode: 'contrastBrightnessMode',
  panMode: 'panMode',
  zoomMode: 'zoomMode',
  scrollThroughVolumeMode: 'scrollThroughVolumeMode',
};
